module.exports = __webpack_public_path__ + "static/media/grimace.c89c1c8f.svg";